<template>
    <li class="product-item" @click="handleClickItem">
        <img :src="prodInfo.logoUrl" alt="" :class="{ smallLogo: size ==='small' }">
        <div class="short-desc" :class="{ shortSmllDesc: size ==='small' }">
            <span>{{ prodInfo.name }}</span>
            <div>{{ prodInfo.desc }}</div>
        </div>
    </li>
</template>
<script>
export default {
  props: {
    prodInfo: {
      type: Object,
      default: () => {}
    },
    size: {
      type: String,
      default: () => 'middle'
    }
  },
  data () {
    return {
      prodInfo2: {
        name: '直播云',
        desc: '多场景直播服务平台',
        logoUrl: '../../../../assets/pngs/icon_mfx.png',
        type: 0,
        redirectUrl: '',
        redirectType: '',
        clickType: true
      }
    }
  },
  methods: {
    handleClickItem () {
      this.$emit('productItemClicked', this.prodInfo)
    }
  }
}
</script>
<style lang="scss" scoped>
.product-item {
    padding: 10px;
    display: flex;
    margin-bottom: 30px;
    cursor: pointer;
    border-radius: 8px;
    .smallLogo {
      width: 52px;
      height: 52px;
    }
    .short-desc {
      margin-left: 24px;
      display:flex;
      flex-direction: column;
      /* center代表水平方向 */
      justify-content: center;
      img {
        width: 70px;
        height: 70px;
      }
      span {
          font-weight: 500;
          font-size: 15px;
      }
      div {
          font-size: 12px;
          font-weight: 500;
          color: #707070;
          line-height: 19px;
      }
    }
    .shortSmllDesc {
      margin-left: 13px;
    }
}

.product-item:hover {
  background: #F7F9FC;
}
</style>
